import { PaidStatus } from "hero24-types"
import {
  PREPAID_STATUS_COLORS,
  PREPAID_STATUS_DEFAULT_COLOR,
} from "../constants"

export const getPrepaidStatusColor = (prepaid?: PaidStatus) =>
  prepaid ? PREPAID_STATUS_COLORS[prepaid] : PREPAID_STATUS_DEFAULT_COLOR
